module.exports = __webpack_public_path__ + "img/loader.a1a26569.svg";